module.exports = __webpack_public_path__ + "static/media/nft-25.7deef628.jpg";